import { render, staticRenderFns } from "./ElectricityStatistics.vue?vue&type=template&id=6ee90864&scoped=true&"
import script from "./ElectricityStatistics.vue?vue&type=script&lang=js&"
export * from "./ElectricityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ElectricityStatistics.vue?vue&type=style&index=0&id=6ee90864&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee90864",
  null
  
)

export default component.exports